import { render, staticRenderFns } from "./TopicHighlights.vue?vue&type=template&id=d8601260"
import script from "./TopicHighlights.vue?vue&type=script&lang=ts"
export * from "./TopicHighlights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports